import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animación de shimmer
const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const SkeletonItem = styled.div`
  background-color: ${props => props.theme.skeletonBase || props.theme.divider};
  border-radius: 8px;
  height: ${props => props.height || '100px'};
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;
  
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: ${shimmer} 1.8s ease-in-out infinite;
  }
`;

const MessageSkeleton = styled.div`
  padding: 15px;
  border-bottom: 1px solid ${props => props.theme.divider};
  margin-bottom: 10px;
`;

const HeaderRow = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const AvatarSkeleton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => props.theme.skeletonBase || props.theme.divider};
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: ${shimmer} 1.8s ease-in-out infinite;
  }
`;

const NameSkeleton = styled(SkeletonItem)`
  width: 150px;
  height: 15px;
  margin-top: 5px;
`;

const TimeSkeleton = styled(SkeletonItem)`
  width: 80px;
  height: 12px;
  margin-top: 5px;
`;

const TextSkeleton = styled(SkeletonItem)`
  width: 100%;
  height: ${props => props.height || '15px'};
  margin-bottom: 10px;
`;

const ActionsSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-top: 20px;
`;

const ActionSkeleton = styled(SkeletonItem)`
  width: 80px;
  height: 20px;
`;

const HashtagSkeleton = styled(SkeletonItem)`
  width: 100px;
  height: 24px;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const SkeletonLoader = ({ type, count = 1 }) => {
  const renderMessageSkeleton = () => (
    <MessageSkeleton>
      <HeaderRow>
        <AvatarSkeleton />
        <div>
          <NameSkeleton />
          <TimeSkeleton />
        </div>
      </HeaderRow>
      <TextSkeleton height="15px" />
      <TextSkeleton height="15px" />
      <TextSkeleton height="15px" width="50%" />
      <ActionsSkeleton>
        <ActionSkeleton />
        <ActionSkeleton />
        <ActionSkeleton />
      </ActionsSkeleton>
    </MessageSkeleton>
  );

  const renderHashtagSkeleton = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {Array.from({ length: count }).map((_, index) => (
        <HashtagSkeleton key={index} />
      ))}
    </div>
  );

  return (
    <>
      {Array.from({ length: type === 'hashtag' ? 1 : count }).map((_, index) => (
        <React.Fragment key={index}>
          {type === 'message' && renderMessageSkeleton()}
          {type === 'hashtag' && renderHashtagSkeleton()}
        </React.Fragment>
      ))}
    </>
  );
};

export default SkeletonLoader;
